import { API } from 'aws-amplify';

export const read = (trainingId, ceoId) =>
  API.get('eventmanagerPublicApi', `/public/training/${trainingId}/ceo/${ceoId}`, { });

export const removeGuest = (trainingId, ceoId, guestId) =>
  API.del('eventmanagerPublicApi', `/public/training/${trainingId}/ceo/${ceoId}/guest/${guestId}`, { });

export const createGuest = (trainingId, ceoId, guest) =>
  API.put('eventmanagerPublicApi', `/public/training/${trainingId}/ceo/${ceoId}/guest`, { body: { guest, ceoId } });

export const addGuests = (trainingId, ceoId, guests) =>
  API.post('eventmanagerPublicApi', `/public/training/${trainingId}/ceo/${ceoId}/guests`, { body: { guests, ceoId } });
